import { FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { makeAutoObservable } from 'mobx';
import { Agent } from 'types/idTrackerService';

export class AgentDetailsDelegate {
  public form = FormController.create(
    {
      firstName: new FormControl<string>('', { validations: ['printableCharacters'] }),
      lastName: new FormControl<string>('', { validations: ['printableCharacters'] }),
      email: new FormControl<string>('', { validations: ['isEmailValid'] }),
      phone: new FormControl<string>('', { validations: ['isValidUSAPhoneNumber'], optional: true }),
      npn: new FormControl<string>('', { validations: ['validNpn'], optional: true }),
      city: new FormControl<string>('', { validations: ['printableCharacters'], optional: true }),
      address: new FormControl<string>('', {
        validations: ['printableCharacters'],
        optional: true,
      }),
    },
    {
      capabilities: [{ type: 'zip', params: { zip: { optional: true } } }],
    },
  );

  private _formIsHidden = true;

  public get isFormHidden(): boolean {
    return this._formIsHidden;
  }

  public setFormIsHidden(isHidden: boolean): void {
    this._formIsHidden = isHidden;
  }

  public resetDelegate(): void {
    this.form.resetForm();
    this.setFormIsHidden(true);
  }

  public get isFormValid(): boolean {
    return this.form.basicFieldsValidationsPassed;
  }

  public populateAgentDetails(agent: Agent): void {
    this.form.populateFields({
      firstName: agent.firstName,
      lastName: agent.lastName,
      email: agent.email,
      phone: agent.phone,
      npn: agent.npn,
      address: agent.address,
      city: agent.city,
      zip: agent.zip,
      state: agent.state,
      county: agent.county,
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
